<template>
    <v-container
        fluid
        class="pa-6">
        <div class="headline font-weight-bold pb-4">
            {{ $t('treasureHunt.header') }}
        </div>

        <v-card>
            <v-card-title
                class="px-4">
                <v-tabs v-model="tab">
                    <v-tab>
                        {{ $t('treasureHunt.treasureHeader') }}
                    </v-tab>
                </v-tabs>
            </v-card-title>

            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <treasure-list-view
                        ref="treasureListView"
                        :treasures="treasures"/>
                </v-tab-item>
            </v-tabs-items>
        </v-card>

        <v-pagination
            v-show="showPagination"
            class="pt-2"
            :style="{
                marginRight: '-8px'
            }"
            :value="page"
            :length="pageTotal"
            :total-visible="totalVisible"
            @input="onPaginationChanged"
        />
    </v-container>
</template>

<script>
import TreasureListView from '@/views/lists/TreasureListView'
import PaginationMixin from '@/mixins/PaginationMixin'

import { mapState } from 'vuex'

export default {
    name: 'TreasureHuntPage',

    mixins: [PaginationMixin],

    components: {
        TreasureListView
    },

    data () {
        return {
            tab: null
        }
    },

    computed: {
        ...mapState('treasureHunt', ['treasures', 'total'])
    },

    mounted () {
        this.initialize()
    },

    methods: {
        initialize () {
            this.$store.dispatch('treasureHunt/fetchTreasures')
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-pagination {
    justify-content: right;
    margin-right: -12px;
}
</style>
